import { Options } from '../options.interface';
import { BANKING_PROCESSOR_API_CONFIG } from './banking-processor-api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BankingPersonalInformation, toBankingPersonalInformation } from '@wizbii/utils/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class BankingPersonalInformationWebservice {
  readonly #http = inject(HttpClient);
  readonly #bankingProcessorApiConfig = inject(BANKING_PROCESSOR_API_CONFIG);

  readonly #baseUrl = this.#bankingProcessorApiConfig.baseUrl;

  readonly get = (userId: string, options?: Options): Observable<BankingPersonalInformation> =>
    this.#http
      .get<object>(`${this.#baseUrl}/v1/user/${userId}/personalInformation`, options)
      .pipe(map(toBankingPersonalInformation));

  readonly update = (
    userId: string,
    bankingPersonalInformation: BankingPersonalInformation,
    options?: Options
  ): Observable<BankingPersonalInformation> =>
    this.#http
      .put<object>(`${this.#baseUrl}/v1/user/${userId}/personalInformation`, bankingPersonalInformation, options)
      .pipe(map(toBankingPersonalInformation));

  readonly getPrefill = (userId: string, options?: Options): Observable<BankingPersonalInformation> =>
    this.#http
      .get<object>(`${this.#baseUrl}/v1/user/${userId}/personalInformation/prefill`, options)
      .pipe(map(toBankingPersonalInformation));
}
